// Small-image helper.
//
// The backend can serve a cached WebP variant of any artwork via
// `?w=160|320|640`. Grids, strips and list rows don't need the
// ~110 KB original, so they ask for the size they actually paint —
// that is the difference between an instant gallery and a slow one on
// a weak mobile connection. Detail views keep using the original.
const ALLOWED = [160, 320, 640];

export const thumb = (url, width = 320) => {
  if (typeof url !== 'string' || !url) return url;
  if (!url.includes('/api/images/')) return url;
  const w = ALLOWED.includes(width) ? width : 320;
  return `${url}${url.includes('?') ? '&' : '?'}w=${w}`;
};

export default thumb;
